import { Component, OnInit } from '@angular/core';
import { AdjustmentModel } from '../../../models/adjustment.model';
import { AdjustmentService } from '../../../services/adjustment.service';
import { ActivatedRoute } from '@angular/router';
import { AdjustmentAccountPeriodModel } from '../../../models/adjustmentAccountPeriod.model';
import { formatNumber } from '@angular/common';
import { LanguageConstants } from 'src/app/shared-components/constant';
import { LanguageHelperService } from 'src/app/services/language.helper.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-viewadjust',
  templateUrl: './viewadjust.component.html',
  styleUrls: ['./viewadjust.component.css']
})
export class ViewadjustComponent implements OnInit {
  public adjustment: AdjustmentModel;
  adjustmentId = +this.route.snapshot.paramMap.get('id');
  public engagementId = +this.route.snapshot.paramMap.get('engagementid');
  loadspinner = false;
  currLangTranslation: any;
  langCode: string;

  constructor(private adjustmentService: AdjustmentService
    ,private route: ActivatedRoute, private languageHelper: LanguageHelperService, private translateService: TranslateService
    ) { }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.getAdjustment();

    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.langCode = langEvent.lang;
      this.currLangTranslation = langEvent.translations;
      this.getAdjustment();
    });

  }

 getAdjustment() {
   this.loadspinner = true;
    this.adjustmentService.getAdjustment(this.adjustmentId)
      .subscribe((data: AdjustmentModel) => {
        this.adjustment = data;
        
        this.adjustmentService.getAdjustmentAccountPeriod(this.adjustmentId, this.engagementId)
          .subscribe((data1: AdjustmentAccountPeriodModel[]) => {
            this.adjustment.adjustmentAccountPeriods = data1;

            data1.forEach(element =>{
              const month = element.Period.substring(0,3); 
              element.Period = this.languageHelper.convertMonthToLocale(this.langCode, month) + element.Period.substring(3, element.Period.length);
            });

            const uniqueAccounts = data1.filter((obj, pos, arr) => {
              return arr.map(mapObj => mapObj['AccountName']).indexOf(obj['AccountName']) === pos;
            });

            const uniquePeriods = data1.filter((obj, pos, arr) => {
              return arr.map(mapObj => mapObj['Period']).indexOf(obj['Period']) === pos;
            });

            this.adjustment.accountName = uniqueAccounts.map(function (val) {
              return val.AccountName;
            }).join(',');
            this.adjustment.periodName = uniquePeriods.map(function (val) {
              return val.Period;
            }).join(',');

            this.loadspinner = false;
          }, error => {

          });
      }, error => {
        this.loadspinner = false;
      });
  }

  private getFormattedNumber(plainNumber: any, langCode: string) {
    let isNegative = false;
    if (!isNaN(plainNumber)) {
      if (plainNumber && plainNumber !== '-') {
        isNegative = !(+plainNumber > 0);
        plainNumber = formatNumber(plainNumber,  langCode , '1.2-2');
      }
      if (!isNegative)
        return plainNumber;
      else
        return `(${+plainNumber * -1})`;
    }
    else
      return plainNumber;

  }


}
